<template>
  <div id="users_support">
    <h2 class="users_support_title">感谢您的支持！</h2>
    <div class="users_support_con">
      <div class="users_support_select" @click.stop="selectclick">
        <h5>赞助获赠插件载入功能值</h5>
        <div v-for="i in $store.state.system_supportrmb" :key="i.rmb" :data-qf="`support${i.rmb}`" :class="{users_support_active:nowm == i.rmb}">{{i.rmb}}元 <span>获取</span> {{i.sqlgrid}}<i class="users_support_iconbox"></i><i class="users_support_icon el-icon-check"></i></div>
        <div class="users_support_btn" @click.stop="zzclick" :style="isclick==0?'':'background:#ccc;'">{{isclick==0?'赞助':`等待${isclick}秒`}}</div>
      </div>
      <div class="users_support_2code">
        <h5>点击赞助后请在此手机扫码支付</h5>
        <span class="u_s2sm">(说明:在支付完成或取消此单之前一次只能创建一个二维码)</span>
        <div class="us_2codecon">
          <div class="us_title">
            <span class="us_title1" :style="showtime==0?'display:none;':'display: inline-block;'">微信支付</span>
            <span class="us_title2" :style="showtime==0?'display:none;':'display: inline-block;'">距二维码过期还剩<span class="us_title3">{{showtime}}</span>秒，过期后请重新点击赞助按钮获取二维码</span>
          </div>
          <div class="us_qrcode">
            <div id="qrcode" ref="qrcode"></div>
          </div>
          <div class="us_qrcodesm" :style="showtime==0?'display:none;':'display: inline-block;'">请使用手机微信扫一扫 扫描二维码支付</div>
          <div class="us_qxbtbox">
            <div :class="showtime>0?'us_qxbtn':'us_qxbtn us_qxbtnc'" @click.stop="qxclick" :style="isqxclick==0?'':'background:#ccc;'">{{isqxclick==0?'取消此单':`等待${isqxclick}秒`}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="users_support_explain">
      <h4>常见问题</h4>
      <div class="users_support_wt">
        <span class="el-icon-question"></span><h5>插件载入功能值如何使用？有无限制？</h5>
      </div>
      <div class="users_support_hd">
        <p>答：插件载入功能值只用于本站开发的插件端单一功能，没有时间限制，是大家对我们团队认可后的一种回馈形式，事先声明：一旦赞助成功，不接受任何形式的退款。请支付钱款之前慎重考虑。另：网站的所有素材都是非必需注册免费开放下载，所有原创及非原创资料供大家免费交流学习使用，请下载后24小时删除。</p>
      </div>
      <div class="users_support_wt">
        <span class="el-icon-question"></span><h5>插件载入功能值使用量？</h5>
      </div>
      <div class="users_support_hd">
        <p>答：在网页中每点击一次素材中的此功能会预先检查本地库是否存在相关素材，如存在，则不会减少此值。所有素材触发此值减分都按模型-3、材质-2、贴图-1计算。</p>
      </div>
      <div class="users_support_wt">
        <span class="el-icon-question"></span><h5>插件载入功能值在重复使用同一素材会减少吗？</h5>
      </div>
      <div class="users_support_hd">
        <p>答：使用过的素材会自动备份在本地，重复使用同一素材会优先使用本地数据，不会减少。</p>
      </div>
    </div>
  </div>
</template>

<script>
import {support,delsupport,issupport} from 'network/users.js'
import QRCode from 'qrcodejs2'
export default {
  name:'users_support',
  data() {
    return {
      nowm:10,
      fee:10,
      isclick:0,
      isqxclick:0,
      showtime:0,
      tradeId:0,
      timer:null
    }
  },
  methods: {
    settime(){
      setTimeout(()=>{
        if(this.isclick==0){return}
        if(this.isclick>0){
          this.isclick --
          this.settime()
        }
      },1000)
    },
    settime_qx(){
      setTimeout(()=>{
        if(this.isqxclick==0){return}
        if(this.isqxclick>0){
          this.isqxclick --
          this.settime_qx()
        }
      },1000)
    },
    settime_showtime(){
      if(this.showtime==0){
        this.zdqx()
        return
      }
      this.timer = setTimeout(()=>{
        if(this.showtime>0){
          this.showtime --
          if(this.showtime % 5 === 0){
            // console.log(this.showtime);
            this.getispay()
          }
          this.settime_showtime()
        }
      },1000)
    },
    getispay(){
      issupport(this.$store.state.phone,this.tradeId,this.fee).then(res=>{
        // console.log(res);
        if(res.state === 0){ 
          this.$store.state.sqlgrid = res.grid
          this.showtime = 0
          this.tradeId = 0
          this.fee = 0
          this.$refs.qrcode.innerHTML = "";
          try{window.clearTimeout(this.timer)}catch(e){}
          this.$elMessage(res.msg,"success",true,30000)
        }
      })
    },
    qrcode(t) {
      this.$refs.qrcode.innerHTML = "";
      let qrcode = new QRCode("qrcode", {
        width: 200, // 二维码宽度，单位像素
        height: 200, // 二维码高度，单位像素
        text: t // 生成二维码的链接
      });
      this.showtime = 120
      this.settime_showtime()
    },
    selectclick(ev){
      switch(ev.target.dataset.qf){
        case('support10'):
        this.nowm = 10
        break
        case('support25'):
        this.nowm = 25
        break
        case('support49'):
        this.nowm = 49
        break
        case('support99'):
        this.nowm = 99
        break
        case('support199'):
        this.nowm = 199
        break
        case('support399'):
        this.nowm = 399
        break
        case('support799'):
        this.nowm = 799
        break
      }
    },
    zzclick(){
      if(this.isclick!=0){return}
      this.isclick=3
      support(this.$store.state.phone,this.nowm).then((res)=>{
        this.settime()
        if(res.state != 0 && res.code == 4){
          this.$elMessage(res.msg,"error",true)
          return
        }
        if(res.code == 6){
          this.nowm = res.fee
          this.fee = res.fee
          this.tradeId = res.tradeId
          this.$elMessage(res.msg,"success",true)
          this.qrcode(res.qrurl)
        }else if(res.code == 0){
          this.nowm = res.fee
          this.fee = res.fee
          this.tradeId = res.tradeId
          this.qrcode(res.qrurl)
        }
      }).catch((e)=>{
        this.settime()
      })
    },
    zdqx(){
      if(!this.tradeId){return}
      delsupport(this.$store.state.phone,this.tradeId).then((res)=>{;
        if(res.state == 0){
          this.showtime = 0
          this.tradeId = 0
          this.$refs.qrcode.innerHTML = "";
          try{window.clearTimeout(this.timer)}catch(e){}  
        }
      })
    },
    qxclick(){
      if(this.isqxclick!=0 || this.showtime < 1){return}
      if(!this.tradeId){return}
      this.isqxclick=3
      this.settime_qx()
      delsupport(this.$store.state.phone,this.tradeId).then((res)=>{;
        if(res.state == 0){
          this.showtime = 0
          this.tradeId = 0
          this.$refs.qrcode.innerHTML = "";
          try{window.clearTimeout(this.timer)}catch(e){}
        }
      })
    }
  },
  beforeRouteEnter(to,from,next){
    next(vm=>{
      if(!vm.$store.state.username){
        vm.$router.push('/home')
        vm.$store.state.reg_logVisible = true
      }
    })
  }
}
</script>

<style>
#users_support{
  flex: 1;
  overflow-y: scroll;
  background-color: rgb(240, 240, 240);
  padding: 25px 35px 0;
}
.users_support_title{
  color: rgb(91, 94, 100);
}
.users_support_explain{
  color: rgb(91, 94, 100);
  display: flex;
  flex-flow:column nowrap;
}
.users_support_wt > span{
  float: left;
  font-size: 14px;
}
.users_support_wt > h5{
  float: left;
  margin: 0 3px;
}
.users_support_hd{
  font-size: 13px;
}
.users_support_con{
  width: 950px;
  height: 490px;
  box-shadow:  0 2px 12px rgba(0, 0, 0,0.2);
  background-color: rgb(236, 227, 226);
  border-radius: 2px;
  display: flex;
  flex-flow:row nowrap;
  padding: 20px;
}
.users_support_select{
  flex: 1;
  border-right: 1px solid rgb(212, 212, 212);
}
.users_support_select h5{
  margin: 5px 0 30px;
  color: rgb(106, 109, 112);
}
.users_support_select div{
  overflow: hidden;
  margin: 5px auto;
  width: 200px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border: 1px solid rgb(126, 131, 136);
  color: rgb(126, 131, 136);
  border-radius: 5px;
  cursor: pointer;
  position: relative;
}
.users_support_select div .users_support_iconbox{
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 0;
  height: 0;
  border-bottom: 30px solid var(--color-high-text);
  border-left: 30px solid transparent;
  display: none;
}
.users_support_select div .users_support_icon{
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 20px;
  height: 15px;
  color: #fff;
  display: none;
}
.users_support_select .users_support_btn{
  border:none;
  color: #fff;
  background-color: var(--color-high-text);
}
.users_support_select .users_support_btn:hover{
  background-color: rgb(50, 116, 192);
}
.users_support_select div span{
  font-size: 12px;
  pointer-events: none;
}
.users_support_2code{
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  
}
.users_support_2code > h5 {
  margin: 0px 20px 0px;
  color: rgb(106, 109, 112);
}
.users_support_2code > .u_s2sm{
  font-size: 10px;
  color: rgb(106, 109, 112);
  margin: 5px 20px 20px;
}
.users_support_select .users_support_active{
  color: var(--color-high-text);
  border: 1px solid var(--color-high-text);
}
.users_support_select .users_support_active .users_support_icon,.users_support_select .users_support_active .users_support_iconbox{
  display: inline-block;
}
.us_2codecon{
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  justify-content:space-between;
  /* align-items:center; */
  padding: 0 0 0 20px;
}
.us_title{
  height: 23px;
}
.us_title2{
  margin-left: 20px;
  font-size: 11px;
}
.us_title3{
  color: rgb(212, 0, 0);
  font-weight: 600;
}
.us_qrcode{
  width: 260px;
  height: 260px;
  border: 1px solid rgb(212, 212, 212);
  display: flex;
  justify-content: center;
  align-items: center;
}
.us_qxbtbox{
  height: 43px;
  display: flex;
  justify-content:flex-end;
}
.us_qxbtn{
  margin-right: 20px;
  width: 150px;
  height: 43px;
  color: #fff;
  background-color: var(--color-high-text);
  line-height: 43px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}
.us_qxbtn:hover{
  background-color: rgb(50, 116, 192);
}
.us_qxbtnc{
  display: none;
}
.us_qrcodesm{
  font-size: 11px;
  letter-spacing:3px;
  color: #333;
}
</style>